<template>
  <div class="wgtSettings">
    <div class="cardR">
      <div class="boxR">
        <div class="fc myZoomClass" id="fancySnap">
          <div class="modal-content filterHolder mdl mdbox" v-show="settingPopShow">
            <div class="modal-header">
              <h5 class="modal-title">Select Filter Levels</h5>
              <div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close"
                v-on:click="settingPopShow = !settingPopShow;">
                <div class="leftright"></div>
                <div class="rightleft"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="col-12 filterModbx">
                <div class="row mr15top" v-for="(addFilters, index) in treemaplevel" :key="addFilters">
                  <div class="col-6 col-md-8 col-lg-10">
                    <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="addFilters.filterval"
                      selectLabel="" :options="getdropsdata" :multiple="false" :allow-empty="false"
                      deselect-label="can't Deselect" :close-on-select="true" placeholder="Pick" track-by="name"
                      label="name" />
                  </div>
                  <div class="col-3 col-md-2 col-lg-1">
                    <button class="btn minusBtn" v-on:click="modifylevel(index, 0)" :disabled="index == 0"
                      title="click to remove filter" v-show="treemaplevel.length == index + 1">
                      <i class="fas fa-minus"></i>
                    </button>
                  </div>
                  <div class="col-3 col-md-2 col-lg-1">
                    <button class="btn addBtn" v-on:click="modifylevel(index, 1)" :disabled="!treemaplevel.length"
                      title="click to add filter" v-show="treemaplevel.length == index + 1">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="effect btn-apply eff-md" v-on:click="getTreeMap(1)">
                Apply
              </div>
            </div>
          </div>
          <div id="fancyChartDiv">
            <div class="content-panel1">
              <div class="insideL  hide-on-presentation ">
                <div class="icon">
                  <font-awesome-icon icon="fa-solid fa-bars" />
                </div>
                <div class="contents">
                  <span v-show="!IscustTreeErr">
                    <font-awesome-icon :icon="['fas', 'eye']" title="Show Blank Values" v-on:click="removeBlank(true)"
                      v-if="isRemoveBlank" />
                    <font-awesome-icon :icon="['fas', 'eye-slash']" title="Hide Blank Values"
                      v-on:click="removeBlank(false)" v-else />
                    <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" v-on:click="addToSlider()"
                      title="Add to Storyboard" />
                    <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                      v-on:click="downloadDom()" />
                  </span>
                </div>
              </div>
              <div class="insideR hide-on-presentation">
                <div class="icon">
                  <font-awesome-icon icon="fa-solid fa-info" />
                </div>
                <div class="contents">
                  {{ $parent.widgetInfo.cust_treemap }}
                  <br />
                  <br />
                  Actions you can take on this widget: <br />
                  <ul>
                    <li>Click on
                      <font-awesome-icon class="actIcon" icon="fa-solid fa-cog" /> to open settings
                    </li>
                    <li>Click on
                      <font-awesome-icon class="actIcon" :icon="['fas', 'eye']" /> to see non blank values and
                      <font-awesome-icon class="actIcon" :icon="['fas', 'eye-slash']" /> to see blank values
                    </li>
                    <li>Click on
                      <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to add to storyboard
                    </li>
                    <li>Click on
                      <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to download the chart with
                      current insight
                    </li>
                  </ul>
                </div>
              </div>
              <div v-show="!isDrilldownLoaded">
                <widgetLoadingComp></widgetLoadingComp>
              </div>
              <div v-show="isDrilldownLoaded" class="settingDiv"></div>
              <div v-show="settingPopShow" class="settingDiv"></div>
              <div class="panel-body text-center panelbodyDiy" id="myPanelFCBody"
                :class="{ 'BlurClass': !isDrilldownLoaded || settingPopShow }">
                <div class="row lgndHldr hide-on-presentation" style="margin-left: 40px;margin-right: 40px;">
                  <div class="myArrowRght text-ellipsis">
                    <div :style="{ 'background-color': colorHolderBg[0], 'border-color': colorHolder[0] }" class="myTreeLevel">
                    </div>
                    Root
                  </div>
                  <div class="myArrowRght text-ellipsis" v-for="(level, index) in treemaplevel" :key="level">
                    <div :style="{ 'background-color': colorHolderBg[index + 1], 'border-color': colorHolder[index + 1] }"
                      class="myTreeLevel"></div>
                    {{ level.filterval.name }}
                  </div>
                </div>
                <div class="row hide-on-presentation" style="margin: 10px 0 0 0">
                  <div class="col-10 text-center">
                    <div class="segmented-control" role="group">
                      <div class="segmented-control_btn grpBtnC fancyButtonC" :class="{ 'themeclr': selDDChart == 1 }"
                        v-on:click="drawTreeMap(this.isRemoveBlank)">
                        Treemap View
                      </div>
                      <div class="segmented-control_btn grpBtnC fancyButtonC" :class="{ 'themeclr': selDDChart == 2 }"
                        v-on:click="drawTree(this.isRemoveBlank)">
                        Tree View
                      </div>
                      <div class="segmented-control_btn grpBtnC fancyButtonC" :class="{ 'themeclr': selDDChart == 3 }"
                        v-on:click="drawSun(this.isRemoveBlank)">
                        Sunburst View
                      </div>
                    </div>
                  </div>
                  <div class="col-2">
                    <font-awesome-icon icon="fa-solid fa-cog" title="Open Settings"
                      class="myfaBtn cursor-pointer hide-on-presentation" v-on:click="settingPopShow = !settingPopShow;" />
                  </div>
                </div>
                <div v-show="istreemapData || IscustTreeErr" class="content-panel1 widgetError text-center">
                  <apiErrorComponent @tryReload="tryReload" compTitle="" compId="chart-container">
                  </apiErrorComponent>
                </div>
                <div id="chart-container" style="height: 80%; margin-bottom: 10px;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var myChartCustDD;
function reportWindowSizeDD() {
  if (myChartCustDD != undefined) {
    myChartCustDD.resize()
  }
}
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import domtoimage from "dom-to-image-more";
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue'
import {
  saveAs
} from 'file-saver';
var treemap_nBlank
var treemap_Blank
var cusTreeData
export default {
  name: 'CustTreeMap',
  mixins: [screenShotMix],
  props: {
    getPins: Object,
    getDrops: Array,
    tabname: String,
  },
  components: {
    apiErrorComponent,
    widgetLoadingComp
  },
  data() {
    return {
      IscustTreeErr: false,
      istreemapData: false,
      isDrilldownLoaded: false,
      fancyChartName: "",
      treemaplevel: [],
      settingPopShow: false,
      isRemoveBlank: false,
      getdropsdata: this.getDrops,
      colorHolder: ["rgb(253, 55, 56)", "rgb(247, 99, 12)", "rgb(255, 185, 0)", "rgb(75, 192, 192)",
        "rgb(54, 162, 235)", "rgb(136,23,152)"
      ],
      colorHolderBg: ["rgba(253, 55, 56, 0.5)", "rgba(247, 99, 12, 0.5)", "rgba(255, 185, 0, 0.5)",
        "rgba(75, 192, 192, 0.5)", "rgba(54, 162, 235, 0.5)", "rgba(136,23,152, 0.5)"
      ],
      selDDChart: 1,
      isChartRedraw: true,
    }
  },
  methods: {
    tryReload() {
      this.getTreeMap(0);
    },
    addToSlider() {
      let insArr = [];
      let name = "Treeview - " + this.getPins.viewName;
      let screenShort = {
        id: 'fancySnap',
        name: 'fancySnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    drawTreeMap(isBlank) {
      this.selDDChart = 1;
      const self = this;
      var emit = this.$emit
      this.fancyChartName = "TreeMap View"
      if (isBlank) {
        cusTreeData = treemap_Blank
      } else {
        cusTreeData = treemap_nBlank
      }
      var chartDom = document.getElementById('chart-container');
      if(chartDom == null) return;
      chartDom.className = ''
      chartDom.classList.add("drawTreeMap")
      if (chartDom != null && chartDom != undefined) {
        if (this.isChartRedraw) {
          this.isChartRedraw = false;
          myChartCustDD = echarts.init(chartDom, null, {
            renderer: 'svg',
            useDirtyRect: false
          });
        }
        var option;
        option = {
          visualMap: {
            type: 'continuous',
            top: 0,
            calculable: false,
            min: 0,
            max: cusTreeData.children[0].value / 2,
            inRange: {
              color: this.$store.state.chartColor,
            },
            textStyle: {
              color: '#777',
              fontSize: 10
            },
          },
          tooltip: {},
          backgroundColor: 'transparent',
          series: [{
            name: cusTreeData.name,
            roam: false,
            type: 'treemap',
            visibleMin: 300,
            data: cusTreeData.children,
            leafDepth: 1,
            label: {
              position: 'insideTopLeft',
              formatter: function (params) {
                let lebPer = (params.value / params.treePathInfo.reverse()[1].value) * 100;
                return params.name + '\n' + params.value + '(' + Number.parseFloat(lebPer).toFixed(2) + '%)'
              },
            },
            levels: [{
              colorAlpha: [0.5, 0.75],
              itemStyle: {
                color: '#f7630c',
                borderColor: 'transparent',
                borderWidth: 2,
                gapWidth: 2
              }
            },
            {
              colorAlpha: [0.5, 0.75],
              itemStyle: {
                color: '#f7630c',
                gapWidth: 2,
                borderWidth: 2
              }
            },
            {
              colorAlpha: [0.5, 0.75],
              itemStyle: {
                color: '#ffb900',
                gapWidth: 1
              }
            },
            {
              colorSaturation: [0.5, 0.75],
              itemStyle: {
                color: '#4bc0c0',
                gapWidth: 1
              }
            },
            {
              colorSaturation: [0.5, 0.75],
              itemStyle: {
                color: '#36a2eb',
                gapWidth: 1
              }
            },
            {
              colorSaturation: [0.5, 0.75],
              itemStyle: {
                color: '#881798',
                gapWidth: 1
              }
            }
            ]
          }]
        }
        myChartCustDD.setOption(option, {
          notMerge: true
        });
        myChartCustDD.on('click', function (params, event) {
          if (params.componentSubType === 'treemap' || params.componentSubType === 'sunburst') {
            let filterStr = self.treemaplevel.map(item => item.filterval.dbname)
            let currpass = params.treePathInfo.slice(1).map((item, index) => item.name)
            let count = 0
            for (let i = 0; i < currpass.length; i++) {
              if (currpass[i] === '(Blanks)') {
                count++
              }
            }
            let clickitem;
            if (filterStr.length === currpass.length) {
              clickitem = {
                "currpass": currpass.join('~'),
                "filterop": filterStr.join('~'),
                "splcond": "DIY"
              }
              if (count < 1) {
                emit("getKDrill", clickitem)
              }
            }
          } else if (params.componentSubType === 'tree') {
            let filterStr = self.treemaplevel.map(item => item.filterval.dbname)
            let currpass = params.treeAncestors.slice(2).map((item, index) => item.name)
            let count = 0
            for (let i = 0; i < currpass.length; i++) {
              if (currpass[i] === '(Blanks)') {
                count++
              }
            }
            let clickitem;
            if (filterStr.length === currpass.length) {
              clickitem = {
                "currpass": currpass.join('~'),
                "filterop": filterStr.join('~'),
                "splcond": "DIY"
              }
              if (count < 1) {
                emit("getKDrill", clickitem)
              }
            }
          }
        })
      }
    },
    drawTree(isBlank) {
      if (myChartCustDD != undefined) {
        echarts.dispose(myChartCustDD);
        this.isChartRedraw = true
      }
      this.selDDChart = 2;
      this.fancyChartName = "Tree View"
      var custSunBurst_data
      if (isBlank) {
        custSunBurst_data = treemap_Blank
      } else {
        custSunBurst_data = treemap_nBlank
      }
      var chartDom = document.getElementById('chart-container');
      if(chartDom == null) return;
      chartDom.className = ''
      chartDom.classList.add("drawTree")
      if (chartDom != null && chartDom != undefined) {
        if (this.isChartRedraw) {
          this.isChartRedraw = false;
          myChartCustDD = echarts.init(chartDom, null, {
            renderer: 'svg',
            useDirtyRect: false
          });
        }
        var option;
        option = {
          visualMap: {
            type: 'continuous',
            top: 0,
            calculable: true,
            min: 0,
            max: custSunBurst_data.children[0].value / 2,
            inRange: {
              color: this.$store.state.chartColor,
            },
            textStyle: {
              color: '#777',
              fontSize: 10
            },
          },
          tooltip: {
            confine: true,
            trigger: 'item',
            triggerOn: 'mousemove'
          },
          series: [{
            type: 'tree',
            data: [custSunBurst_data],
            initialTreeDepth: 1,
            symbolSize: 15,
            label: {
              position: 'left',
              verticalAlign: 'middle',
              align: 'right',
              fontSize: 9
            },
            leaves: {
              label: {
                position: 'right',
                verticalAlign: 'middle',
                align: 'left'
              }
            },
            levels: [{
              colorAlpha: [0.5, 0.75],
              itemStyle: {
                color: '#f7630c',
                borderColor: 'transparent',
                borderWidth: 2,
                gapWidth: 2
              }
            },
            {
              colorAlpha: [0.5, 0.75],
              itemStyle: {
                color: '#f7630c',
                gapWidth: 2,
                borderWidth: 2
              }
            },
            {
              colorAlpha: [0.5, 0.75],
              itemStyle: {
                color: '#ffb900',
                gapWidth: 1
              }
            },
            {
              colorSaturation: [0.5, 0.75],
              itemStyle: {
                color: '#4bc0c0',
                gapWidth: 1
              }
            },
            {
              colorSaturation: [0.5, 0.75],
              itemStyle: {
                color: '#36a2eb',
                gapWidth: 1
              }
            },
            {
              colorSaturation: [0.5, 0.75],
              itemStyle: {
                color: '#881798',
                gapWidth: 1
              }
            }
            ],
            expandAndCollapse: true,
            animationDuration: 550,
            animationDurationUpdate: 750
          }]
        }
        myChartCustDD.setOption(option, {
          notMerge: true
        });
      }
    },
    drawSun(isBlank) {
      this.selDDChart = 3;
      this.fancyChartName = "Sunburst View"
      var custSunBurst_data
      if (isBlank) {
        custSunBurst_data = treemap_Blank
      } else {
        custSunBurst_data = treemap_nBlank
      }
      var chartDom = document.getElementById('chart-container');
      if(chartDom == null) return;
      chartDom.className = ''
      chartDom.classList.add("drawSun")
      if (chartDom != null && chartDom != undefined) {
        if (this.isChartRedraw) {
          this.isChartRedraw = false;
          myChartCustDD = echarts.init(chartDom, null, {
            renderer: 'svg',
            useDirtyRect: false
          });
        }
        var option;
        option = {
          visualMap: {
            type: 'continuous',
            calculable: true,
            top: 0,
            min: 0,
            max: custSunBurst_data.children[0].value / 2,
            inRange: {
              color: this.$store.state.chartColor,
            },
            textStyle: {
              color: '#777',
              fontSize: 10
            },
          },
          series: {
            type: 'sunburst',
            data: custSunBurst_data.children,
            radius: [0, '90%'],
            itemStyle: {
              borderRadius: 7,
              borderWidth: 2
            },
            labelLayout: {
              hideOverlap: true
            },
            label: {
              rotate: 'radial'
            }
          }
        };
        myChartCustDD.setOption(option, {
          notMerge: true
        });
      }
    },
    removeBlank(isBlank) {
      if (isBlank == true) {
        this.isRemoveBlank = false
      } else {
        this.isRemoveBlank = true
      }
      if (this.selDDChart == 1) {
        setTimeout(() => {
          this.drawTreeMap(this.isRemoveBlank)
        }, 5)
      } else if (this.selDDChart == 2) {
        setTimeout(() => {
          this.drawTree(this.isRemoveBlank)
        }, 5)
      } else if (this.selDDChart == 3) {
        setTimeout(() => {
          this.drawSun(this.isRemoveBlank)
        }, 5)
      }
    },
    modifylevel(pos, vals) {
      if (vals == 0) {
        this.treemaplevel.splice(pos, 1)
      } else {
        if (pos < 4) {
          this.treemaplevel.push({
            filterval: {}
          })
        } else {
          this.$notify({
            type: "error",
            text: 'Sorry! Filter limit Reached!'
          })
        }
      }
    },
    checkDuplicate(arr) {
      for (let i = 0; i < arr.length; i++) {
        for (let j = 1; j < arr.length; j++) {
          if (i !== j) {
            if (arr[i].filterval.dbname == arr[j].filterval.dbname || arr[i].filterval.dbname == undefined) {
              return true
            }
          }
        }
      }
      return false
    },
    blank_iterate(leveldata) {
      for (var i = 0; i < leveldata.length; i++) {
        if (leveldata[i].name == "(Blanks)") {
          leveldata.splice(i, 1)
          i--
        } else {
          if (leveldata[i].children.length != 0) {
            this.blank_iterate(leveldata[i].children)
          }
        }
      }
    },
    getTreeMap(isfilter) {
      if (isfilter == 1) {
        var dupsChk = this.checkDuplicate(this.treemaplevel)
      }
      if (dupsChk == true) {
        this.$notify({
          type: "warn",
          text: 'Sorry! Filter values cannot contain Same and Blank values. Try with different filters!'
        })
      } else {
        if (isfilter == 1) {
          this.settingPopShow = !this.settingPopShow
        }
        this.IscustTreeErr = false
        this.istreemapData = false
        this.isDrilldownLoaded = false
        this.fancyChartNo = 4
        this.axios.post(this.uriApiUrl + 'DataAnalysis/sunburst_view?asg_id=' + this.asgId, {
          "filterlevel": this.treemaplevel,
          "selid": this.getPins.selid,
          "edited": this.getPins.edited,
          "cond": 1
        },{
      headers: {
            'Content-Type': 'application/json'
          }})
          .then((response) => {
            if (response.status == 200) {
              if (response.data == "Error") {
                this.IscustTreeErr = true;
                this.isDrilldownLoaded = true;
                this.$notify({
                  type: "error",
                  text: 'Sorry! Something went wrong in DIY Treemap view. Try after sometime!'
                })
              } else {
                var respdata = response.data.custsundata
                if (respdata != "Error" && respdata != "Nodata") {
                  var cusTreeWhole = response.data
                  cusTreeData = cusTreeWhole.custsundata
                  this.treemaplevel = []
                  for (let index = 0; index < cusTreeWhole.filterlvl.length; index++) {
                    this.treemaplevel.push({
                      filterval: cusTreeWhole.filterlvl[index]
                    })
                  }
                  treemap_nBlank = JSON.parse(JSON.stringify(cusTreeData.children))
                  treemap_Blank = JSON.parse(JSON.stringify(cusTreeData.children))
                  this.blank_iterate(treemap_Blank)
                  treemap_Blank = {
                    children: treemap_Blank,
                    name: cusTreeData.name
                  }
                  treemap_nBlank = {
                    children: treemap_nBlank,
                    name: cusTreeData.name
                  }
                  if (this.isChartRedraw) {
                    try {
                      echarts.dispose(myChartCustDD);
                    } catch (error) {
                      // console.log("..")
                    }
                  }
                  if (this.selDDChart == 1) {
                    setTimeout(() => {
                      this.drawTreeMap(this.isRemoveBlank)
                    }, 5)
                  } else if (this.selDDChart == 2) {
                    setTimeout(() => {
                      this.drawTree(this.isRemoveBlank)
                    }, 5)
                  } else if (this.selDDChart == 3) {
                    setTimeout(() => {
                      this.drawSun(this.isRemoveBlank)
                    }, 5)
                  }
                } else if (response.data == "Nodata") {
                  this.istreemapData = true
                  this.treemaplevel = response.data.filterlvl
                } else {
                  this.IscustTreeErr = false
                  this.treemaplevel = response.data.filterlvl
                  this.$notify({
                    type: "error",
                    text: 'Sorry! Something went wrong in DIY Treemap view. Try after sometime!'
                  })
                }
                this.isDrilldownLoaded = true
              }
            }
          }).catch((response) => {
            this.IscustTreeErr = true
            this.isDrilldownLoaded = true
            if (this.enabledDebug == 1) {
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in DIY Treemap view. Try after sometime!'
              })
            }
          })
      }
    },
    downloadDom() {
      let removeSpaceName = this.fancyChartName.replace(/ /g, "_");
      let imgname = removeSpaceName + ".png"
      let widgetID = "fancyChartDiv"
      var geticondiv = document.querySelectorAll('#fancyChartDiv .insideL,#fancyChartDiv .insideR, #fancyChartDiv .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.isChartRedraw = true;
    this.getTreeMap(0);
    window.addEventListener("resize", reportWindowSizeDD);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeDD);
  },
  watch: {
    '$store.state.chartColor': function () {
      if (myChartCustDD != undefined) {
        this.getTreeMap(0);
      }
    }
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#myPanelFCBody {
  height: 115vh;
  padding-top: 14px;
  margin-bottom: 10px;
}

.filterHolder {
  z-index: 30;
  width: 80%;
  left: 10%;
  top: 35px;
}

.wgtSettings {
  min-height: 940px;
  height: 125vh;
}

.wgtSettings .cardR {
  min-height: 920px;
  width: 100%;
  height: calc(120vh + 30px);
  overflow: hidden;
}

.wgtSettings .cardR .content-panel1 {
  height: 120vh;
  padding: 10px;
}

.lgndHldr::before {
  position: absolute;
  top: -20px;
  left: 12px;
}

.myfaBtn {
  height: 25px;
  width: 25px;
  padding: 5px;
  border-radius: 5px;
}

/* @media (max-width: 991.98px){
    #myPanelFCBody {
      height: 100%;
      width: 100%;
    }
    .wgtSettings .cardR .content-panel1 {
      height: auto;
    }
  } */
.wgtSettings .cardR .content-panel1 {
  height: auto;
  overflow: visible;
}
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>